import React, { Suspense, useCallback, useRef } from "react";
import ReactDOM from "react-dom";
import { Icon, Loader, PlainButton, Tooltip } from "@culturehq/components";

import { useDoor } from "app/hooks";
import { t } from "app/utils";

import Slides from "./Slides";
import styles from "./slideshow.module.scss";

const LazySlides = props => (
  <Suspense fallback={<Loader loading />}>
    <Slides {...props} />
  </Suspense>
);

const Slideshow = ({ children, onFetch }) => {
  const triggerRef = useRef();
  const { open, onOpen, onClose } = useDoor(false);

  const onSlidesClose = useCallback(
    () => {
      triggerRef.current.focus();
      onClose();
    },
    [triggerRef, onClose]
  );

  return (
    <>
      <PlainButton className={styles.slideshow} ref={triggerRef} onClick={onOpen}>
        <Tooltip tip={t("View slideshow")}>
          <Icon icon="slides" />
        </Tooltip>
      </PlainButton>
      {open && ReactDOM.createPortal(
        <LazySlides onClose={onSlidesClose} onFetch={onFetch} onRender={children} />,
        document.body
      )}
    </>
  );
};

export default Slideshow;
